import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import type { ClienteMapa } from '../types/visita.types';

// AIDEV-NOTE: Icones customizados usando L.divIcon com cores MUI
// Verde com checkmark = tem agenda hoje; azul padrao = sem agenda

const agendadoIcon = L.divIcon({
  html: `<div style="width:28px;height:28px;background:#2e7d32;border:2px solid white;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.3)">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
  </div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
  className: ''
});

const defaultIcon = L.divIcon({
  html: `<div style="width:24px;height:24px;background:#1976d2;border:2px solid white;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  popupAnchor: [0, -12],
  className: ''
});

interface Props {
  cliente: ClienteMapa;
  onCheckin?: () => void;
  onVerHistorico?: () => void;
}

export function ClienteMarker({ cliente, onCheckin, onVerHistorico }: Props) {
  // AIDEV-NOTE: Clientes sem coordenadas nao sao exibidos no mapa
  if (cliente.lat == null || cliente.lng == null) return null;

  const icon = cliente.tem_agenda_hoje ? agendadoIcon : defaultIcon;

  return (
    <Marker position={[cliente.lat, cliente.lng]} icon={icon}>
      <Popup minWidth={220} maxWidth={300}>
        <Box sx={{ p: 0.5 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            {cliente.nome}
          </Typography>

          {(cliente.endereco || cliente.cidade) && (
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5 }}>
              <LocationOnIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {[cliente.endereco, cliente.cidade].filter(Boolean).join(' - ')}
              </Typography>
            </Stack>
          )}

          {cliente.tem_agenda_hoje && (
            <Chip
              icon={<CheckCircleIcon />}
              label="Agendado hoje"
              size="small"
              color="success"
              sx={{ mb: 1 }}
            />
          )}

          {cliente.ultima_visita && (
            <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 1 }}>
              Ultima visita: {new Date(cliente.ultima_visita).toLocaleDateString('pt-BR')}
            </Typography>
          )}

          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {onCheckin && (
              <Button variant="contained" size="small" color="primary" onClick={onCheckin}>
                Check-in
              </Button>
            )}
            {onVerHistorico && (
              <Button variant="outlined" size="small" onClick={onVerHistorico}>
                Historico
              </Button>
            )}
          </Stack>
        </Box>
      </Popup>
    </Marker>
  );
}
